<div class="content-wrapper">
    <div class="content-body">
        <div id="user-profile">
            <div class="row">
                <div class="col-12">
                    <div class="card profile-header mb-2">
                        <img class="card-img-top" src="{{university?.university_cover_file?.url}}"
                             alt="{{university?.name}}"/>
                        <div class="position-relative">
                            <div class="profile-img-container d-flex align-items-center">
                                <div class="profile-img">
                                    <img src="{{university?.university_icon_file?.url}}"
                                         class="rounded img-fluid"
                                         alt="Card image"/>
                                </div>
                                <div class="profile-title ml-3">
                                    <h2 class="text-white">{{university?.name}}</h2>
                                    <p class="text-white">{{university?.city?.name}}, {{university?.state?.name}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="profile-header-nav">
                            <nav class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100">
                                <button
                                        class="btn btn-icon navbar-toggler"
                                        type="button"
                                        data-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                        (click)="toggleMenu = !toggleMenu"
                                        rippleEffect
                                >
                                    <i data-feather="align-justify" class="font-medium-5"></i>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent"
                                     [ngbCollapse]="toggleMenu">
                                    <div class="profile-tabs d-flex justify-content-between flex-wrap mt-1 mt-md-0">
                                    <ul class="nav nav-pills mb-0">
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('overview')">
                                                <span class="d-none d-md-block">Overview</span>
                                                <i data-feather="rss" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('courses')">
                                                <span class="d-none d-md-block">Courses</span>
                                                <i data-feather="book-open" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('courses-fees')">
                                                <span class="d-none d-md-block">Courses & Fees</span>
                                                <i data-feather="info" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('fee-details')">
                                                <span class="d-none d-md-block">Fee Details</span>
                                                <i data-feather="dollar-sign" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('admission')">
                                                <span class="d-none d-md-block">Admission</span>
                                                <i data-feather="users" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('admission-steps')">
                                                <span class="d-none d-md-block">Admission Steps</span>
                                                <i data-feather="list" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('stats')">
                                                <span class="d-none d-md-block">Stats</span>
                                                <i data-feather="bar-chart-2" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold active" (click)="goTo('recruiters')">
                                                <span class="d-none d-md-block">Recruiters</span>
                                                <i data-feather="briefcase" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('faculty')">
                                                <span class="d-none d-md-block">Faculty</span>
                                                <i data-feather="user" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('why-choose')">
                                                <span class="d-none d-md-block">Why Choose</span>
                                                <i data-feather="list" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('faqs')">
                                                <span class="d-none d-md-block">FAQs</span>
                                                <i data-feather="help-circle" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('infrastructure')">
                                                <span class="d-none d-md-block">Infrastructure</span>
                                                <i data-feather="image" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link font-weight-bold" (click)="goTo('contact')">
                                                <span class="d-none d-md-block">Contact</span>
                                                <i data-feather="users" class="d-block d-md-none"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section id="profile-info">
                <div class="row">
                    <div class="col-lg-12 col-12 order-1 order-lg-2">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="form-group mb-2">
                                    <div class="card">
                                        <div class="card-header">
                                            <h2>Recruiters</h2>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <small>Company Name</small>
                                                    <input class="form-control" [(ngModel)]="name"/>
                                                </div>
                                                <div class="col-md-6">
                                                    <small>Logo</small>
                                                    <input class="form-control" type="file" accept="image/*"
                                                           (change)="onLogoSelected($event)">
                                                    <small *ngIf="uploadingLogo">Uploading...</small>
                                                    <img *ngIf="logoPreviewUrl" [src]="logoPreviewUrl"
                                                         class="img-fluid rounded mt-1" style="max-height: 60px" alt="Logo preview"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-primary pull-right" rippleEffect
                                                    (click)="addDetail()" [disabled]="submitting">
                                                <span class="font-weight-bold">Add</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="card">
                                    <div class="card-body">
                                        <table class="table table-list">
                                            <thead>
                                            <tr>
                                                <th class="text-center">
                                                    <h6 class="mt-1 mb-1 font-weight-bold">Logo</h6>
                                                </th>
                                                <th class="text-center">
                                                    <h6 class="mt-1 mb-1 font-weight-bold">Name</h6>
                                                </th>
                                                <th class="text-center">
                                                    <h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody *ngIf="recruiters && recruiters.length > 0; else noDataToShowWeb">
                                            <tr *ngFor="let recruiter of recruiters">
                                                <td class="text-center">
                                                    <img *ngIf="recruiter?.logo_file?.url" [src]="recruiter.logo_file.url"
                                                         class="img-fluid rounded" style="max-height: 40px" alt="Logo"/>
                                                </td>
                                                <td class="text-center">
                                                    <h6 class="mt-1">{{recruiter?.name}}</h6>
                                                </td>
                                                <td class="text-center">
                                                    <i class="fas fa-trash font-small-4 text-danger cursor-pointer"
                                                       (click)="delete(recruiter.id)"></i>
                                                </td>
                                            </tr>
                                            </tbody>
                                            <ng-template #noDataToShowWeb>
                                                <tbody>
                                                <tr>
                                                    <td class="text-center" colspan="3">
                                                        <h6 class="mt-1">No data to show</h6>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </ng-template>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
